import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { queryClient } from '../pages/journeys/data/queryClient';

// Cached journey data is per-tenant. When the active tenant (groups[0]) changes
// — tenant switch or logout/login in the same tab — drop the cache so the next
// user never sees the previous tenant's data. Renders nothing.
export default function QueryCacheReset() {
  const tenant = useSelector((s) => s.loginReducer?.groups?.[0]);
  const prev = useRef(tenant);
  useEffect(() => {
    if (prev.current !== tenant) {
      queryClient.clear();
      prev.current = tenant;
    }
  }, [tenant]);
  return null;
}
